import { render } from "./prenotaPerClienteModal.vue?vue&type=template&id=532fd919&scoped=true&ts=true"
import script from "./prenotaPerClienteModal.vue?vue&type=script&lang=ts"
export * from "./prenotaPerClienteModal.vue?vue&type=script&lang=ts"

import "./prenotaPerClienteModal.vue?vue&type=style&index=0&id=532fd919&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532fd919"]])

export default __exports__